module.exports = __webpack_public_path__ + "static/img/trigger.50b618b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/trigger.svg
// module id = uGfN
// module chunks = 46